import { device } from 'constants/device';

import styled from 'styled-components';

export const Container = styled.div`
  max-height: 24px;
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

export const Image = styled.img`
  max-width: 50px;
  height: auto;
  max-height: inherit;
  object-fit: contain;
  object-position: left;
  margin-right: 6px;
  @media ${device.tablet} {
    max-width: 20px;
    margin-right: 4px;
  }
`;

export const ImagePlaceholder = styled(Image)`
  max-width: 36px;
  @media ${device.tablet} {
    max-width: 18px;
   }
`
export const Title = styled.p`
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 140%;
  color: ${({ theme }) => theme.system.black};
  max-width: 175px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  @media ${device.tablet} {
    max-width: 100px;
    white-space: normal;
    font-size: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
